var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"caption"},[_c('div',[_vm._v(" "+_vm._s(_vm.caption)+" ")]),(_vm.icon)?_c('font-awesome-icon',{attrs:{"icon":_vm.icon},on:{"click":_vm.exec}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }